import { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useFieldStyles } from 'components/UI/FieldStyles';
import { commonStyles } from 'Theme';
import { PetServiceWrapper } from 'model/NewMultipleBooking';
import { PriceField2 } from 'components/UI';

export interface PriceFieldProps {
    id?: string;
    label?: string | JSX.Element;
    name?: string;
    selectedOption?: PetServiceWrapper;
    placeholder?: string;
    className?: string;
    default?: string;
    onChange: (option: PetServiceWrapper, data: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            minWidth: 110
        },
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '16px',
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 20
            }
        }
    })
);

export const PriceField: FunctionComponent<PriceFieldProps> = props => {
    const classes = useStyles();
    const commonClasses = commonStyles();
    const fieldClasses = useFieldStyles();

    const changeHandler = (value: number | undefined) => {
        if (props.selectedOption) {
            const optionSelected = { ...props.selectedOption };
            optionSelected.price = value || 0;
            optionSelected.customPriceAmount = value || 0;
            props.onChange(optionSelected, true);
        }
    };

    return (
        <Box className={clsx(classes.container, fieldClasses.container, props.className)}>
            <Typography className={classes.title}>{props.label}</Typography>
            <PriceField2
                id={props.id}
                value={props.selectedOption?.price}
                scale={2}
                precision={6}
                default={props.default}
                onChange={changeHandler}
                className={clsx(commonClasses.field, props.className)}
                placeholder={props.placeholder}
            />
        </Box>
    );
};

export default PriceField;
